let translateUrl;

if (process.env.NODE_ENV === 'production') {
  translateUrl = 'https://hub.stellamedi.com/api/translation/getAllJson'
} else {
  // Lokal tünelle dışarı açarken HubApi'nin tünel adresi `.env.local` ile verilir.
  translateUrl = process.env.VUE_APP_TRANSLATE_URL || 'http://localhost:27000/api/translation/getAllJson'
}

export default {
  webBaseURL: process.env.MIX_APP_URL,
  translateUrl
}
